<template>
  <div
    :class="[
      'main-wrapper',
      'c-flex-1',
      isSidebarExpanded ? '' : 'min-sidebar'
    ]"
  >
    <div class="main-sidebar" style="z-index:999">
      <Sidebar
        :menuList="routerConfig"
        :routerName="routerName"
        @menu-click="menuClicked"
        v-if="isSidebarExpanded"
      ></Sidebar>
      <div class="pin-sidebar-new" @click="toggleSidebar">
        <i class="sidebar-toggle-top"></i>
        <i
          class="sidebar-toggle-icon c-icon icon icon-expand-16"
          :class="{ 'icon-shrink-16': isSidebarExpanded }"
        ></i>
        <i class="sidebar-toggle-bottom"></i>
      </div>
    </div>
    <div class="main-container">
      <!--<Main></Main>-->
      <MainBanner
        @menu-click="breadClicked"
        @region-clicked="regionClicked"
        :bread="pathSet"
        :regions="regions"
      />
      <div class="content c-bg-white main-content">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </div>
    </div>
    <Dialog
      v-model="showAuth"
      size="small"
      :title="dialog.title"
      :ok="ok"
      @cancel="onCancel"
      @terminate="onCancel"
    >
      <div>
        您还未取得公测资源，请<a
          href="https://console.ksyun.com/pro/singlepage/metaapply.html?type=product&id=KQES"
        >
          申请公测
        </a>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Sidebar from '@/layout/Sidebar.vue';
import MainBanner from '@/layout/Mainbanner';
import { routes } from '@/router';
import { requestAuth, requestIsNew } from '@/apis/auth';
import { REGION_LIST } from '@/apis/const';
import Dialog from 'kpc/components/dialog';
export default {
  provide() {
    return {
      global: {
        region: this.regions,
        currentRegion: 'currentRegion',
        savePath: this.globalData.savePath
      }
    };
  },
  components: {
    Sidebar,
    // Main,
    MainBanner,
    Dialog
  },

  data() {
    return {
      showAuth: false,
      dialog: {
        content: '',
        title: ''
      },
      isSidebarExpanded: true,
      // 面包屑当前路径
      pathSet: [],
      // 数据中心
      regions: REGION_LIST,
      routerConfig: routes,
      targetRouter: null,
      routerName: ''
    };
  },
  methods: {
    toggleSidebar() {
      this.isSidebarExpanded = !this.isSidebarExpanded;
    },
    regionClicked(item) {
      console.log(item);
    },
    makeBreadcrumb(router) {
      this.pathSet = [router];
      router.current ? this.pathSet.push(router.current) : '';
    },
    breadClicked() {
      // console.log(router)
    },
    menuClicked(router) {
      this.targetRouter = router;
      let name = router.current ? router.current.name : router.name;
      this.$router.push({ name });
    },
    async ok() {
      window.location.replace(
        'https://console.ksyun.com/pro/singlepage/metaapply.html?type=product&id=KQES'
      );
    },
    async onCancel() {
      window.location.href = '//console.ksyun.com';
    },
    async isNew() {
      try {
        await requestIsNew();
        return true;
      } catch (error) {
        return true;
      }
    },
    async init() {
      this.showLoading();
      try {
        let res = await requestAuth();
        this.globalData.auth = true;
        this.globalData.savePath = res.data.Total.SavePath;
        window.localStorage.setItem('savePath', res.data.Total.SavePath || '');
        sessionStorage.setItem('KQESGETROLE', 'OK');
        // 授权页，跳转到首页
        if (this.$route.name === 'noAuth') {
          this.$router.push({ name: 'qeMetaManage' });
        }
      } catch (error) {
        switch (error.data.Status) {
          case 401:
            this.$router.push({ name: 'noAuth' });
            break;
          case 402: // 申请公测
            this.dialog.title = '没有权限';
            this.showAuth = true;
            break;
          default:
            this.$router.push({ name: 'error' });
            this.Message['error'](` ${error.msg}`);
            break;
        }
      }
      this.hideLoading();
    }
  },

  watch: {
    $route(to) {
      this.routerName = to.name;
      let kqesAuthInfo = sessionStorage.getItem('KQESISNEW') || '';
      let kqesAuthRole = sessionStorage.getItem('KQESGETROLE') || '';
      console.log(
        'getRole:',
        kqesAuthRole,
        'getNew:',
        kqesAuthInfo,
        'to:',
        this.routerName
      );
      if (kqesAuthInfo == 208 && this.routerName == 'auth') {
        this.$router.push({ name: 'qeMetaManage' });
        return;
      }
      let noCheckRouters = ['error', 'noAuth'];
      if (noCheckRouters.indexOf(this.routerName < 0) && !kqesAuthInfo) {
        console.log('1. getNew');
        requestIsNew().then(
          res => {
            console.log('requestIsNew:', res);
            if (res.data.Total.Status == 207) {
              sessionStorage.setItem('KQESISNEW', 207);
              console.log('1. to auth');

              this.$router.push({ name: 'auth' });
              this.hideLoading();
              return;
            }
            sessionStorage.setItem('KQESISNEW', 208);
            if (this.routerName == 'auth') {
              this.$router.push({ name: 'qeMetaManage' });
              return;
            }
            requestAuth().then(
              res => {
                console.log(res);
                sessionStorage.setItem('KQESGETROLE', 'OK');
                let router = this.targetRouter || to;
                this.makeBreadcrumb(router);
                this.targetRouter = null;
              },
              error => {
                console.log(error);
                switch (error.data.Status) {
                  case 401:
                    this.$router.push({ name: 'noAuth' });
                    break;
                  case 402: // 申请公测
                    this.dialog.title = '没有权限';
                    this.showAuth = true;
                    break;
                  default:
                    this.$router.push({ name: 'error' });
                    this.Message['error'](` ${error.msg}`);
                    break;
                }
              }
            );
            let router = this.targetRouter || to;
            this.makeBreadcrumb(router);
            this.targetRouter = null;
            this.hideLoading();
            return;
          },
          error => {
            console.log(error);
            this.Message['error']('获取用户信息失败');
            this.$router.push({ name: 'auth' });
            this.hideLoading();
            return;
          }
        );
      } else if (
        kqesAuthInfo == 207 &&
        this.routerName != 'auth' &&
        this.routerName != 'noAuth'
      ) {
        this.$router.push({ name: 'auth' });
        this.hideLoading();
        return;
      } else if (!kqesAuthRole && kqesAuthInfo == 208) {
        this.init();
      } else {
        let router = this.targetRouter || to;
        this.makeBreadcrumb(router);
        this.targetRouter = null;
        this.hideLoading();
      }
    }
  },

  created() {
    console.log('App Created');
    // 授权验证
    // this.init();
  },

  mounted() {}
};
</script>
